import type { FC, ReactNode } from 'react'

export interface PanelProps {
  /** Section number, printed identically on screen and on the PDF. */
  n?: string
  title: string
  aside?: ReactNode
  children?: ReactNode
  /** An anchor to scroll to — the Summary's line counts jump to their grid. */
  id?: string
}

/** A card: a title row, an optional aside on the right, then the body. */
export const Panel: FC<PanelProps> = ({ n, title, aside, children, id }) => (
  <section className="panel" {...(id ? { id } : {})}>
    <div className="panel__head">
      {n ? <span className="panel__n">{n}</span> : null}
      <h2 className="panel__title">{title}</h2>
      {aside ? <div className="panel__aside">{aside}</div> : null}
    </div>
    <div className="panel__body">{children}</div>
  </section>
)
